export default "__VITE_ASSET__3e286097__"